import { Link } from 'react-router';
import { PageHeader } from '../ui/PageHeader';

export function Forbidden() {
  return (
    <div className="text-center py-5">
      <i className="bi bi-shield-lock display-4 text-body-tertiary" aria-hidden />
      <h1 className="h4 mt-3">You don’t have access to this page</h1>
      <p className="text-body-secondary">Ask an administrator to grant you access.</p>
      <Link to="/" className="btn btn-primary">Back to dashboard</Link>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="text-center py-5">
      <PageHeader title="Page not found" />
      <p className="text-body-secondary">The page you are looking for does not exist.</p>
      <Link to="/" className="btn btn-primary">Back to dashboard</Link>
    </div>
  );
}
